import { BaseModel } from '../base.model';
import { JsonProperty } from '../json-map.util';

class UserModel extends BaseModel {
  id: number = undefined;
  email: string = undefined;
  firstName: string = undefined;
  lastName: string = undefined;
}

namespace UserModel {
  export class Complete extends UserModel {
    @JsonProperty({clazz: Date})
    lastLogin: Date = undefined;
  }

  export class FullProfile extends UserModel {
    birthYear: string = undefined;
    gender: string = undefined;
    address1: string = undefined;
    address2: string = undefined;
    city: string = undefined;
    state: string = undefined;
    postalCode: string = undefined;
  }

}

export { UserModel };
